export default __webpack_public_path__ + "static/media/logo.5b6f7cff.png";